export const escapeHtml = (unsafe = '') => {
  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

export const afterSanitizeAttributes = currentNode => {
  if ('target' in currentNode) {
    currentNode.setAttribute('target', '_blank');
  }
};

export const domPurifyConfig = {
  ALLOWED_TAGS: [
    'p', 'br', 'span', 'em', 'strong', 'a', 'b', 'i', 'u',
    'blockquote', 'code', 'pre', 'ul', 'ol', 'li'
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
  ALLOW_DATA_ATTR: false,
  USE_PROFILES: { html: false, svg: false, mathMl: false },
  hooks: {
    afterSanitizeAttributes,
  },
};
